import { addHours, format, isAfter } from 'date-fns';
import { getConfig } from 'config/runtime';

const IMAGE_BASE_URL = getConfig('REACT_APP_IMAGES');

export const convertImageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>
      resolve({
        file: reader.result,
      });
    reader.onerror = (error) => reject(error);
  });
};

export function blobToFile(theBlob, fileName) {
  return new File([theBlob], fileName, {
    lastModified: new Date().getTime(),
    type: theBlob.type,
  });
}

export const setCurrency = (price, currency) => {
  if (typeof price !== 'number') return price;

  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: currency ? currency : 'IDR',
    minimumFractionDigits: 0, // No decimal places
    maximumFractionDigits: 0, // No decimal places
  }).format(price);
};

function validatePhoneWithZero(phoneNumber) {
  const re = /^0\d{9,12}/g;
  return re.test(phoneNumber);
}

function validate62(phoneNumber) {
  const re = /^62\d{9,12}/g;
  return re.test(phoneNumber);
}

export const phoneFormatter = (number) => {
  if (validatePhoneWithZero(number)) {
    const newNumber = number.replace(/^0/g, '62');
    return newNumber;
  }

  if (validate62(number)) {
    return number;
  }
};

export const removePhoneCode = (code, number) => {
  const codeNumber = code.slice(1, code.length);

  function validatePhoneWithCode(number) {
    const form = `^${codeNumber}\\d{9,12}`;
    const re = new RegExp(form, 'g');
    return re.test(number);
  }

  if (validatePhoneWithCode(number)) {
    const replace = `^${codeNumber}`;
    const re = new RegExp(replace, 'g');
    const newNumber = number.replace(re, '');
    return newNumber;
  } else {
    return number.replace(/^0/g, '');
  }
};

// force phone number to have 62 at the start
export const phoneFormatterWithCode = (code, number) => {
  const codeNumber = code.slice(1, code.length);

  function validatePhoneWith0(phoneNumber) {
    const re = /^0\d{9,12}/g;
    return re.test(phoneNumber);
  }

  if (validatePhoneWith0(number)) {
    const newNumber = number.replace(/^0/g, codeNumber);
    return newNumber;
  } else {
    return number;
  }
};

// force phone number to have 0 at the start
// code dalam bentuk string dan masih ada tanda +, contoh "+62"
export const phoneFormatter0 = (code, number) => {
  const codeNumber = code.slice(1, code.length);

  function validatePhoneWithCode(phoneNumber) {
    const form = `^${codeNumber}\\d{9,12}`;
    const re = new RegExp(form, 'g');
    return re.test(phoneNumber);
  }

  if (validatePhoneWithCode(number)) {
    const replace = `^${codeNumber}`;
    const re = new RegExp(replace, 'g');
    const newNumber = number.replace(re, '0');
    return newNumber;
  } else {
    return number;
  }
};

export const phoneWithCode = (code = '', number) => {
  const codeNumber = code.slice(1, code.length);

  function validatePhoneWithCode(number) {
    const form = `^${codeNumber}\\d{9,12}`;
    const re = new RegExp(form, 'g');
    return re.test(number);
  }

  if (/^0\d{9,12}/g.test(number)) {
    return phoneFormatterWithCode(code, number);
  } else if (validatePhoneWithCode(number)) {
    const replace = `^${codeNumber}`;
    const re = new RegExp(replace, 'g');
    const newNumber = number.replace(re, '');
    return codeNumber.concat(newNumber);
  } else return codeNumber.concat(number);
};

export const toPascalCase = (str) =>
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase())
    .join(' ');

export const mappingLongTimeZones = (timeZones) => {
  let newTimeZones = [];

  for (let zone of timeZones) {
    zone.longTimezones.forEach((item) => {
      newTimeZones.push(item);
    });
  }

  return newTimeZones;
};

export const getGMTOffsetString = () => {
  const date = new Date();
  const timezoneOffset = date.getTimezoneOffset();

  const offsetHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
  const offsetMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
  const offsetSign = timezoneOffset > 0 ? '-' : '+';

  return `GMT${offsetSign}${offsetHours}:${offsetMinutes}`;
};

export const checkEmptyObject = (targetObject) => {
  return Object.keys(targetObject).length === 0 && targetObject.constructor === Object;
};

export const checkPermission = (offCanvasMenu, currentMenu, actionType) => {
  const getPermission = offCanvasMenu?.find((item) => item?.name?.toLowerCase() === currentMenu?.toLowerCase());
  if (!getPermission) return;
  return Object.prototype.hasOwnProperty.call(getPermission, 'action')
    ? Boolean(getPermission?.action[actionType])
    : false;
};

export const getStatusOrderState = (statusOrder) => {
  let prevStatus;
  let nextStatus;
  let confirmationMessage;
  let toastSuccessMessage;
  let toastErrorMessage;

  switch (statusOrder) {
    case 'CHECKOUT':
      prevStatus = 'CHECKOUT';
      nextStatus = 'PAID';
      confirmationMessage = 'Apakah anda yakin ingin mengkonfirmasi transaksi?';
      toastSuccessMessage = 'Transaksi Berhasil Dikonfirmasi';
      toastErrorMessage = 'Transaksi Gagal Dikonfirmasi!';
      break;
    case 'PAID':
      prevStatus = 'PAID';
      nextStatus = 'COMPLETED';
      confirmationMessage = 'Apakah anda yakin ingin memproses transaksi?';
      toastSuccessMessage = 'Transaksi Berhasil Diproses';
      toastErrorMessage = 'Transaksi Gagal Diproses!';
      break;
    case 'REVIEWING_IDENTITY':
      prevStatus = 'REVIEWING_IDENTITY';
      nextStatus = 'COMPLETED';
      confirmationMessage = 'Apakah anda yakin ingin memproses transaksi?';
      toastSuccessMessage = 'Transaksi Berhasil Diproses';
      toastErrorMessage = 'Transaksi Gagal Diproses!';
      break;
    default:
      throw new Error('order status not found!');
  }

  return {
    prevStatus,
    nextStatus,
    confirmationMessage,
    toastErrorMessage,
    toastSuccessMessage,
  };
};

export const getDurationExtend = (startTime, initialDuration, endTime) => {
  if (!startTime || !endTime) return;

  const [startH, startM, startS] = startTime.split(':').map(Number);
  const [endH, endM, endS] = endTime.split(':').map(Number);

  const startInSeconds = startH * 3600 + startM * 60 + startS;
  const endInSeconds = endH * 3600 + endM * 60 + endS;

  let diffInSeconds = endInSeconds - startInSeconds;

  // kalau endTime melewati tengah malam
  if (diffInSeconds < 0) {
    diffInSeconds += 24 * 3600;
  }

  const totalHours = diffInSeconds / 3600;
  const extendHours = totalHours - initialDuration;

  return Math.max(extendHours, 0);
};

export const gotFeeCurrency = (fee, currency) => {
  if (!currency || typeof fee !== 'number') return '-';

  if (fee && currency === 'IDR') return setCurrency(fee, currency);
  else if (fee && currency === 'SGD') return `${currency} ${fee.toFixed(2)}`;
  else if (fee === 0) return `${currency} 0`;

  return '-';
};

export const normalizeTimeFormat = (t) => {
  if (!t) return '';

  if (/^\d{2}:\d{2}:\d{2}$/.test(t)) {
    return t;
  }

  if (/^\d{2}:\d{2}$/.test(t)) {
    return `${t}:00`;
  }

  return t;
};

export const isDisabledHour = (hour, rentStart, disabledTimes, staticDisabledTime) => {
  let isDisable = false;

  if (staticDisabledTime && staticDisabledTime.length > 0) {
    const selectedDisabledHours = staticDisabledTime.filter((time) => +time.split(':')[0] === +hour);

    if (selectedDisabledHours && selectedDisabledHours.length > 1) {
      isDisable = true;
    }
  }

  if (disabledTimes && disabledTimes.length > 0 && rentStart) {
    const date = new Date(rentStart);
    if (isNaN(date.getTime())) return false;

    const formattedSelectedDate = format(date, 'yyyy-MM-dd');

    const existingSelectedDisabledDate = disabledTimes.find((item) => item.date === formattedSelectedDate);

    if (existingSelectedDisabledDate) {
      const existingDisabledHour = existingSelectedDisabledDate.times?.filter((item) => +item.split(':')[0] === +hour);

      if (existingDisabledHour && existingDisabledHour.length > 1) {
        isDisable = true;
      }
    }
  }

  return isDisable;
};

export const isDisabledMinute = (hour, minute, rentStart, disabledTimes, staticDisabledTime) => {
  let isDisable = false;

  if (staticDisabledTime && staticDisabledTime.length > 0) {
    const selectedDisabledHours = staticDisabledTime.filter((time) => +time.split(':')[0] === +hour);

    if (selectedDisabledHours && selectedDisabledHours.length > 0) {
      const selectedDisabledMinute = selectedDisabledHours.find((item) => item.split(':')[1] === minute.toString());
      if (selectedDisabledMinute) {
        isDisable = true;
      }
    }
  }

  if (disabledTimes && disabledTimes.length > 0 && rentStart && hour) {
    const date = new Date(rentStart);
    if (isNaN(date.getTime())) return false;

    const formattedSelectedDate = format(date, 'yyyy-MM-dd');

    const existingSelectedDisabledDate = disabledTimes.find((item) => item.date === formattedSelectedDate);

    if (existingSelectedDisabledDate) {
      const existingDisabledHour = existingSelectedDisabledDate.times?.filter((item) => +item.split(':')[0] === +hour);

      if (existingDisabledHour && existingDisabledHour.length > 0) {
        const existingDisabledMinute = existingDisabledHour.find((item) => item.split(':')[1] === minute.toString());

        if (existingDisabledMinute) {
          isDisable = true;
        }
      }
    }
  }

  return isDisable;
};

export const isSelectedTimeValid = (hour, minute, rentStart, disabledTimes, staticDisabledTime) => {
  const isMinuteValid = isDisabledMinute(
    hour.toString().padStart(2, '0'),
    minute.toString().padStart(2, '0'),
    rentStart,
    disabledTimes,
    staticDisabledTime,
  );
  const isHourValid = isDisabledHour(hour.toString().padStart(2, '0'), rentStart, disabledTimes, staticDisabledTime);

  return !isMinuteValid && !isHourValid;
};

export const isDisabledDurationRent = (duration, startRentDate, startRentHour) => {
  let isDisabled = false;

  if (!startRentDate || !startRentHour) return isDisabled;

  const baseDate = addHours(startRentDate, 24);
  const endRentHour = addHours(new Date(`${format(startRentDate, 'yyyy-MM-dd')}T${startRentHour}`), duration);

  if (isAfter(endRentHour, baseDate)) {
    isDisabled = true;
  }

  return isDisabled;
};

export const mappedAreaCharter = (data, charterPricingData) => {
  if (data?.order_detail?.booking_zones) {
    const newAreaCharter = data?.order_detail?.booking_zones.map((area) => {
      const charterDuration = charterPricingData?.find((price) => price.duration === area.charter_duration);

      return {
        booking_start_time: area.booking_start_time,
        booking_end_time: area.booking_end_time,
        charter_duration: charterDuration ?? {},
      };
    });

    return newAreaCharter;
  }

  return [];
};

export const getPaymentValue = (data) => {
  if (data?.type === 'FULL') {
    return 'Pembayaran Full';
  }

  if (data?.type === 'HALF') {
    const percentage = data?.order_detail?.dp_rule?.formula_percentage?.value;
    return percentage ? `Pembayaran DP ${percentage}%` : 'Pembayaran DP';
  }

  return '-';
};

export const getKTPValue = (data, customer, isUploadNewDocumentEnabled) => {
  let ktpValue = '';

  if (data?.is_admin_creation && data?.order_detail?.identity?.ktp) {
    ktpValue = data.order_detail.identity.ktp;
  } else if (customer?.PersonalInfos?.ktp) {
    ktpValue = isUploadNewDocumentEnabled ? customer.PersonalInfos.ktp : IMAGE_BASE_URL + customer.PersonalInfos.ktp;
  }

  return ktpValue;
};

export const getSIMValue = (data, customer, isUploadNewDocumentEnabled) => {
  let simValue = '';

  if (data?.is_admin_creation && data?.order_detail?.identity?.sim) {
    simValue = data.order_detail.identity.sim;
  } else if (customer?.PersonalInfos?.sim) {
    simValue = isUploadNewDocumentEnabled ? customer.PersonalInfos.sim : IMAGE_BASE_URL + customer.PersonalInfos.sim;
  }

  return simValue;
};

export const getPassportValue = (data, customer, isUploadNewDocumentEnabled) => {
  let passportValue = '';

  if (data?.is_admin_creation && data?.order_detail?.identity?.passport) {
    passportValue = data.order_detail.identity.passport;
  } else if (customer?.PersonalInfos?.passport) {
    passportValue = isUploadNewDocumentEnabled
      ? customer.PersonalInfos.passport
      : IMAGE_BASE_URL + customer.PersonalInfos.passport;
  }

  return passportValue;
};
